<template>
  <div class="floor-grade floor">
    <div class="container">
      <h2 class="floor__h2">回收宝4年的成绩</h2>
      <hr class="floor__line">
      <p class="floor__desc">900万用户选择回收宝；回收了1000万台手机；支出回收款项60亿</p>
      <ul class="grid-list clearfix">
        <li class="grid-item" v-for="(item, index) in list" :key="index">
          <img class="grid-item__icon" v-lazy="item.icon">
          <h2 class="grid-item__title" v-text="item.title"></h2>
          <p class="grid-item__dessc" v-text="item.desc"></p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
const list = [{
  icon: '//s1.huishoubao.com/static/pc/1001/img/2_03.png',
  title: '900万+用户',
  desc: '选择我们的用户数'
}, {
  icon: '//s1.huishoubao.com/static/pc/1001/img/2_05.png',
  title: '1000万+台',
  desc: '回收手机数'
}, {
  icon: '//s1.huishoubao.com/static/pc/1001/img/2_07.png',
  title: '60+亿',
  desc: '回收手机总价值（亿）'
}, {
  icon: '//s1.huishoubao.com/static/pc/1001/img/2_09.png',
  title: '42个西湖',
  desc: '保护的无污染水资源量'
}];

export default {
  data () {
    return {
      list
    };
  }
};
</script>

<style lang="postcss" scoped>
.floor-grade {
  background-color: #fff;
}
.grid-list {
  padding-top: 40px;
  padding-bottom: 40px;
}
.grid-item {
  float: left;
  width: 25%;
  text-align: center;
}
.grid-item__title {
  color: #ff5f43;
  font-size: 40px;
  font-weight: bold;
  padding: 30px;
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/welcome/floor-grade.vue